/* GD Variant Defaulter
   Auto-selects the 24-pack option on coffee product pages when the page loads,
   provided no specific variant is already requested via URL.
   Also makes 24-pack visually pre-selected in variant pickers. */

(function () {
  // Only run on product templates
  if (!document.body.classList.contains('template-product') &&
      !document.documentElement.dataset.template &&
      window.location.pathname.indexOf('/products/') === -1) {
    return;
  }

  // Don't override if user explicitly requested a variant via ?variant=...
  if (window.location.search.indexOf('variant=') !== -1) {
    return;
  }

  function selectPreferredOption() {
    // Look for variant pickers - radio inputs or buttons with "24 pack", "24-pack", "24"
    const candidates = document.querySelectorAll(
      'input[type="radio"][name*="option"], button[name*="option"], input[type="radio"].variant-picker__input, button.variant-picker__option'
    );
    if (!candidates.length) return false;

    // Look for a node containing a "24" pack label
    let target = null;
    for (let i = 0; i < candidates.length; i++) {
      const el = candidates[i];
      const text = (el.value || '') + ' ' + (el.textContent || '') + ' ' +
                   (el.nextElementSibling ? el.nextElementSibling.textContent : '') + ' ' +
                   (el.previousElementSibling ? el.previousElementSibling.textContent : '') + ' ' +
                   (el.getAttribute('aria-label') || '') + ' ' +
                   (el.dataset.optionValue || '');
      const t = text.toLowerCase().trim();
      // Match "24 pack", "24-pack", "24pack", "x24", "24 bag", "pack of 24"
      if (/(^|\s|\b|pack\sof\s|x|×)24(\s|-|$|\sbag|\spack|pk)/.test(t)) {
        target = el;
        break;
      }
    }

    if (!target) return false;

    // Don't reselect if already selected
    if (target.checked || target.classList.contains('is-selected') ||
        target.getAttribute('aria-checked') === 'true' ||
        target.getAttribute('data-selected') === 'true') {
      return true;
    }

    // Click it - this triggers Shopify variant picker logic
    target.click();
    return true;
  }

  // Try a few times — variant pickers can mount async after page load
  let attempts = 0;
  const interval = setInterval(function () {
    attempts++;
    if (selectPreferredOption() || attempts > 10) {
      clearInterval(interval);
    }
  }, 250);
})();
